/* eslint-disable @dev-agents/rules/i18n/text-wrapped-in-format-message */
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import Page, { GridColumn } from '@atlaskit/page';
import { Box, Flex, Grid, Stack, Text, xcss } from '@atlaskit/primitives';

import { useAnalyticsWebClient } from '../../utils/analytics/context';
import { ErrorStateImage } from '../home/common/error-state-image';

const contentStyles = xcss({
	textAlign: 'center',
	maxWidth: '480px',
});

// TODO: The message is in this page not valid, this can due to the user cannot access Rovo Dev Agents
// We need to show a different message for the user who cannot access Rovo Dev Agents
export const NoAccessPage = () => {
	const analyticsWebClient = useAnalyticsWebClient();
	return (
		<Page>
			<Grid>
				<GridColumn medium={4}>
					<Flex alignItems="center" justifyContent="center">
						<Box xcss={contentStyles}>
							<Stack space="space.300" alignInline="center">
								<ErrorStateImage />
								<Heading size="medium">Rovo Dev Agents is not installed on this site</Heading>
								<Stack space="space.050">
									<Text as="p" testId="no-access-page-description">
										Rovo Dev Agents may not be installed on this site, or you might still be waiting
										on us to activate the product. Try again later, or{' '}
										<Link
											href="https://rovodevagents-beta.atlassian.net/wiki/external/YmQ4YTllN2EyZTJmNGNmMTkwYTllMTZkYjk2MGRiNDU"
											target="_blank"
											onClick={() => {
												analyticsWebClient.sendUIEvent({
													action: 'clicked',
													actionSubject: 'link',
													actionSubjectId: 'no-access-page-info-link',
													source: 'no-access-page',
												});
											}}
										>
											read how to install Rovo Dev Agents
										</Link>
									</Text>
								</Stack>
							</Stack>
						</Box>
					</Flex>
				</GridColumn>
			</Grid>
		</Page>
	);
};
